import React from "react";
import Dialog from "@mui/material/Dialog";
import { FormikProps } from "formik";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import moment from "moment";
import { FormInitialValues } from "./ExpenseListFilterWrapperDialog";

type Props = {
  formikProps: FormikProps<FormInitialValues>;
  onReset: () => void;
  open: boolean;
  onClose: () => void;
};

const ExpenseListFilterDialog = ({
  open,
  formikProps,
  onReset,
  onClose,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleSubmit } = formikProps;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <div className="flex flex-col gap-3 px-4 py-4">
        <div className="flex justify-between">
          <div className="text-primary-main font-medium text-[18px] ">
            Filters
          </div>
          <button
            type="button"
            className="text-sm text-secondary-main font-medium"
            onClick={() => {
              onReset();
              //   onClose();
            }} // Call onReset when reset button is clicked also with close dialog
          >
            Reset Filters
          </button>
        </div>
        <div className="flex gap-2">
          <div>
            <ATMDatePicker
              name="startDate"
              value={values.startDate}
              onChange={(newValue) => setFieldValue("startDate", newValue)}
              label="Start Date"
              format="DD-MM-YYYY"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>

          <div>
            <ATMDatePicker
              name="endDate"
              value={values.endDate}
              onChange={(newValue) => setFieldValue("endDate", newValue)}
              label="End Date"
              format="DD-MM-YYYY"
              minDate={values?.startDate || undefined}
            />
          </div>
        </div>

        <div className="mt-2 flex justify-between gap-x-2">
          <button
            type="button"
            className="border w-full rounded p-2 h-[42px] flex gap-2 justify-center items-center bg-slate-200 hover:bg-slate-300"
            onClick={onClose} // Call onClsoe when clicked the button
          >
            Close
          </button>
          <ATMLoadingButton
            type="submit"
            isLoading={isSubmitting}
            className="bg-primary-main"
            onClick={() => handleSubmit()}
          >
            Apply
          </ATMLoadingButton>
        </div>
      </div>
    </Dialog>
  );
};

export default ExpenseListFilterDialog;
